import { FormInput } from "semantic-ui-react";

export const NewTextInputFormComponent = (props: {
  props: NewTextInputFormComponentProps;
  data: any;
  setData: any;
}) => {
  const raw = props.data?.[props.props.key];
  const currentValue =
    typeof raw === "string" ? raw : (raw?.name ?? String(raw ?? ""));

  return (
    <FormInput
      fluid
      label={props.props.label}
      required={props.props.required}
      placeholder={props.props.placeholder}
      value={currentValue}
      onChange={(_e: any, { value }: { value: string }) => {
        props.setData({
          ...props.data,
          [props.props.key]:
            raw !== null && typeof raw === "object"
              ? { ...raw, name: value }
              : value,
        });
      }}
    />
  );
};

export type NewTextInputFormComponentProps = {
  type: "text";
  key: string;
  label: string;
  required: boolean;
  placeholder: string;
};
